import { DEFAULT_MAX_ACCESS_DURATION } from "@p0security/shared/configuration/constant";

import { DurationSetting } from "./DurationSetting.tsx";

export const TenantMaxAccessDuration: React.FC = () => (
  <DurationSetting
    description="Set the organization maximum allowable duration for access requests."
    field="maxAccessDuration"
    fallback={DEFAULT_MAX_ACCESS_DURATION}
    label="Organization maximum access duration"
    route="settings/max-access-duration"
  />
);
